// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  production: false,
  enableServiceWorker: true,
  authenticated: false,
  hmr: false,
  debugEnabled: false,
  appVersion: packageJson.version + '-stage',

  BASE_URL: 'https://phdsoft-wdt-front-stage.azurewebsites.net/',
  API_ADMIN: 'https://phdsoft-gateway-stage.azurewebsites.net/admin/api/',
  ADMIN_RAZOR: 'http://phdc4d-admin-razor.azurewebsites.net/',
  API_MEDIA: 'https://phdsoft-gateway-stage.azurewebsites.net/media/api/',
  FCN_IOT: 'https://phdsoft-iot-function-tests.azurewebsites.net/api/',
  API_ML: "https://localhost:44366/api/",
  API_FEA: "https://phdsoft-gateway-stage.azurewebsites.net/fea/api/",
  IOT_API: "https://phdsoft-gateway-stage.azurewebsites.net/iot/api/",
  API_THREED: "https://phdsoft-gateway-stage.azurewebsites.net/threed/api/",
  API_INSPEC: "https://phdsoft-gateway-stage.azurewebsites.net/inspec/api/",
  API_DEGRAD: "https://phdsoft-gateway-stage.azurewebsites.net/degradation/api/",
  RISK_API: "https://phdsoft-gateway-stage.azurewebsites.net/risk/api/",
  API_ASSISTANT: "https://phdsoft-gateway-stage.azurewebsites.net/assistant/api/",
  API_IOT_FUNCTIONS: {
    REALTIME_STREAM: "https://phdsoft-gateway-stage.azurewebsites.net/iothubsignalr/api/",
  },

  SIGNALR_MESSAGES: "https://phdsoft-messages-stage.azurewebsites.net/messagehub",
  GLTF_CONVERTER: "https://phdsoft-gateway-stage.azurewebsites.net/gltfconverter/gltf",
  API_TRACING: "https://phdsoft-gateway-stage.azurewebsites.net/tracing/api/",
  API_STABILITY: "https://phdsoft-gateway-stage.azurewebsites.net/loadwork/api/",
  STABILITY_URL: 'https://stage.hydrostatic.ai-engineer.ai/',
  API_COPILOT_CHAT: 'https://copilot-stg.azurewebsites.net/copilot?code=cUqlVYSIKbs_xv9WoRlugHUWL-567uidm-HNcd9Tv0sOAzFujwes8A==',
  API_COPILOT_FEEDBACK: 'https://copilot-stg.azurewebsites.net/feedback?code=7YDBQ0w_SqYueolXF-VAgDhCHz5U6eAM5pbeEZb-sZf8AzFuwVpZGg==',
  API_COPILOT_TOGGLE: 'https://copilot-stg.azurewebsites.net/toggle?code=wr1tM8MnwcKy5A48faTXdXg34MvMRi8jAYbaJEMSFxZmAzFuczjTdg==',
  ANOMALY_DETECTION_FUNCTION: 'https://open-ai-vision-stage.azurewebsites.net/api/AnalyzeImage/?code=CfQlmEDSZ5Vrz7vzu_MI7XEvmB3-XM6YUMwdpuOD-expAzFuZu-8cQ==',

  SCOUT_PORTAL: {
    // Routed through Angular dev-server proxy (see proxy.conf.json) to avoid
    // CORS and bypass the global HeaderInterceptor that overwrites Authorization.
    BASE_URL: '/scout-api',
    ACCESS_TOKEN: 'iN1q619ewJFIFEKM-mka7mlEc5kAv6m8FIgEXjmvz5CEdAAS5',
    SESSION_CODE: '764192',
  },

  RESEND_TIME: 10,
  NAME: 'STAGE',

  //Mapbox access token
  mapbox: {
    accessToken: 'pk.eyJ1IjoicGhkc29mdCIsImEiOiJjbHA3cmVnZm0xdmx2MmpwNXU0Znh1ejUyIn0.4c4t6iVHJDw4lHP9JB5Gcw'
  },

  // GTLF Decryption Keys
  DEC_KEY: 'pCGJ4ERdxIuUyv/JSeUqBa21FIPuhDHqZpy/KVUviUg=',
  DEC_KEYIV: 'QJb970i7g1gu+ctLWOHZFQ==',

  // PDF Viewer Assets Path - deployed app serves assets at /assets/
  PDF_ASSETS_FOLDER: 'assets',
};
